import React from 'react';
// import { FontAwesomeIcon }  from '@fortawesome/react-fontawesome';
import BannerLogo from '../../assets/images/BannerLogo.webp';

const RegistrationHeader2 = (props) => {
  const { lessonLocation } = props;

  let url = null;
  switch (lessonLocation.toLowerCase()) {
    case 'woodbury':
      url = 'asmwoodbury.com';
      break;
    case 'pitman':
      url = 'asmpitman.com';
      break;
    default:
      url = '1afterschoolmusic.com';
      break;
  };

	return (
		<header className='registrationHeading'>
			<div className='content'>
				<div>
					<img src={BannerLogo} alt="Banner" title="Banner" />
					<p>
						Pitman NJ, Woodbury NJ<br />
						<a href="mailto:pitmanmusiclessons@gmail.com" target="_self">pitmanmusiclessons@gmail.com</a><br />
						<a href="mailto:woodburymusiclessons@gmail.com" target="_self">woodburymusiclessons@gmail.com</a><br />
						Text: 856-55-33-11-0
					</p>
				</div>
				<ul className='registrationPageDesktopMenu'>
					<li><a href={'https://' + url + '/'}>Home</a></li>
					<li><a href={'https://' + url + '/calendars'}>Calendars</a></li>
					<li><a href={'https://' + url + '/teachers'}>Teachers</a></li>
					<li className='active'>Register</li>
					<li><a href={'https://' + url + '/policies-tuition'}>Policies/Tuition</a></li>
				</ul>
			</div>
			<div className='registrationPageBanner'>
				<div className='content twoColumns'>
					<a href='https://forms.gle/WotaZvrDCN2eaTRi6' target='_blank' rel='noreferrer' className='column'>Need to miss a lesson?</a>
					<a href='https://app.mymusicstaff.com/' target='_blank' rel='noreferrer' className='column'>{'Current Client Portal \u{276F}'}</a>
				</div>
			</div>
		</header>
	);
};

export default RegistrationHeader2;
